import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { PageMatchesTypeEnum, PageMatchesOpEnum, DimensionMatchesWithOtherEnum, } from '../../types/campaignsJson';
dayjs.extend(isBetween);
/* ** IS LOCATION MATCHING UTILS ** */
function isPageMatchEmpty(pageMatches) {
    return !(pageMatches === null || pageMatches === void 0 ? void 0 : pageMatches.length);
}
export function removeTrailingSlash(location) {
    if (typeof location !== 'string') {
        throw new Error('Campaign Url Match is required');
    }
    if (location.length > 0 && location.charAt(location.length - 1) === '/') {
        return location.substring(0, location.length - 1);
    }
    return location;
}
function isMatchesSimple(location, match) {
    var url = new URL(location);
    return (removeTrailingSlash(match) ===
        removeTrailingSlash("".concat(url.host).concat(url.pathname)));
}
export function hasNotOperator(op) {
    return op === PageMatchesOpEnum.NOT;
}
export function isReferrerMatch(location, _a) {
    var type = _a.type, match = _a.match, op = _a.op;
    try {
        var result = false;
        switch (type) {
            case DimensionMatchesWithOtherEnum.matches_simple: {
                result = isMatchesSimple(location, match);
                break;
            }
            case DimensionMatchesWithOtherEnum.contains:
                result = location.includes(match);
                break;
            case DimensionMatchesWithOtherEnum.begin_with:
                result = location.startsWith(match);
                break;
            default:
                break;
        }
        return hasNotOperator(op) ? !result : result;
    }
    catch (e) {
        return false;
    }
}
export function isUrlMatch(location, _a) {
    var type = _a.type, match = _a.match, op = _a.op;
    try {
        var result = false;
        var decodedLocation = decodeURIComponent(location);
        switch (type) {
            case PageMatchesTypeEnum.EXACT:
                result = match === decodedLocation;
                break;
            case PageMatchesTypeEnum.SIMPLE: {
                result = isMatchesSimple(decodedLocation, match);
                break;
            }
            case PageMatchesTypeEnum.CONTAINS:
                result = decodedLocation.includes(match);
                break;
            case PageMatchesTypeEnum.BEGINS:
                result = decodedLocation.startsWith(match);
                break;
            default:
                break;
        }
        return hasNotOperator(op) ? !result : result;
    }
    catch (e) {
        return false;
    }
}
export function isLocationMatched(location, pageMatches) {
    if (isPageMatchEmpty(pageMatches)) {
        return false;
    }
    try {
        return !!pageMatches.some(function (matches) {
            var result = matches.filter(function (opt) { return isUrlMatch(location, opt); });
            return result.length === matches.length;
        });
    }
    catch (e) {
        return false;
    }
}
/* ** IS SCHEDULE MATCHING UTILS ** */
export function isScheduleMatched(dateISOString, schedule) {
    var isMatched = dayjs(dateISOString).isBetween(dayjs(schedule.start), dayjs(schedule.end).format(), 'seconds');
    return isMatched;
}
